import React from "react";
import "./Invest.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";


class Invest extends React.Component {
    render() {
        return(
            <div>
            <Nav/>
            <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Invest">01 Investment Environment</a></p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProLoc">Transportation and Logistics</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/InvestRegis"> 02 Investment Registration</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab">03 Industries & Parks</p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoBusiness">Eco-Business Park</a></p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoInov">Eco-Innovation</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Overall">Overall Introduction</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab">04 Real Estate Development</p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevPlan"> Development Plan</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevMile">Development Milestone</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Partners">05 Partners & Potential Investors</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
            </div>
          </div>
        <div className="col-8">
        <div class="abhead7">
        <p></p>
        </div>
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Investment Opportunities</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>Why choose to invest in the Bamboo Ecological Commercial, Industrial & Tourism City (Good Morning Bamboo Eco-City)?</p>
        <p className="text-justify">Good Morning Bamboo Eco-City is a high-level disruptive circular economy project, which has received strong support from the local and international communities.
The Good Morning Bamboo Eco-City is strategically located within the Abura Asebu Kwamankese and Mfantsiman Districts Area in the Central Region which is by the economically thriving regions (The Central Region is bordered by the Ashanti and Eastern regions to the north, Western to the west, Greater Accra to the East and to the south by the Gulf of Guinea), which is part of the Ghana government’s strategy to coordinate development across the regions, providing good opportunities for the growth of companies and industries.
<br/><br/>There will be a range of amenities such as schools, a general hospital, and other public facilities, the Start-Up Area of the Eco-City will become a mature community, thus providing a conducive environment for companies. This will be followed by further development of the centre of the Eco-City.
As a greenfield development, the Eco-City will also become a huge market for various green products and services. It will become a large-scale adoption ground for many eco-solutions and eco-technologies which will push the boundaries of sustainability.
To attract investments to the Good Morning Bamboo Eco-City, the developers of the Eco-City will have work closely with the Government of Ghana to roll out several incentive policies.


</p>
   
       </div>
      
     </div>
   </div>
            </div>
        )
    }
}
export default withRouter(Invest);